import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as InfoGeraisSvg } from '../../assets/icons/cartaServicos/informacoes-gerais.svg';
import { ReactComponent as PrestacaoSvg } from '../../assets/icons/cartaServicos/prestacao.svg';
import { ReactComponent as InformacaoSvg } from '../../assets/icons/cartaServicos/informacao.svg';
import { ReactComponent as LegislacaoSvg } from '../../assets/icons/cartaServicos/legislacao.svg';
import {
  ServicoCabecalhoContainer, ServicoCabecalhoTitulo, ServicoContainer, ServicoConteudoContainer,
  ServicoConteudoItem,
  ServicoConteudoItemTitulo,
  ServicoConteudoItemValor,
  ServicoGrid,
} from './CardCartaServicosEstilo';
import { GridSpaceBetween } from '../../styles/base';
import Botao from '../Botao/Botao';

const abertoDefaultValues = [false, false, false, false];

const CardCartaServicos = ({
  Aplicativo, Aplicativo2, Bairro, Bairro2, CEP, CEP2, DataHoraUltimaAtualizacao, Descricao, Documento, Email, Email2, Endereco, Endereco2, HorarioFuncionamentoAte, HorarioFuncionamentoAte2, HorarioFuncionamentoAte3, HorarioFuncionamentoAte4, HorarioFuncionamentoDe, HorarioFuncionamentoDe2, HorarioFuncionamentoDe3, HorarioFuncionamentoDe4, LinkDecreto, LinkLei, LinkOutros, LinkPortaria, LinkPrograma, LinkResolucao, LinkTaxa, NumeroGLPI, Plataforma, PossuiNumeroGLPI, Prazo, PrazoObservacao, PrincipaisEtapas, PublicoAlvo, Secretaria, Servico, Setor, Site, Telefone01, Telefone02, Telefone03, Telefone04, Valor,
}) => {
  const history = useHistory();

  // Array criado para controlar a "abertura" de cada um dos 4 collapses disponíveis na página.
  const [aberto, setAberto] = useState(abertoDefaultValues);

  // Método usado para dinâmicamente saber qual collapse deverá fechar ou abrir:
  // Eu percorro o Array atual (map), acessando cada item (item) e sua devida posição (index). Com isso, eu vou testando se o index do atual item percorrido
  // bate com a "posicao" que eu enviei via parâmetro (que é a posição que desejo manipular). Caso a posição seja DIFERENTE, eu mantenho o item com o mesmo valor.
  // Caso seja igual (===), então eu altero o valor de "item" para o seu oposto (!item), trocando true para false e vice-versa.
  // fonte: https://horadecodar.com.br/maneira-correta-de-mudar-estado-de-array-em-react-js/
  const handleClick = (posicao) => {
    setAberto((arrayAtual) => arrayAtual.map((item, index) => (index === posicao ? !item : item)));
  };

  /*
  Explicando método abaixo:
  Primeiramente verificamos se TODOS (every) os itens estão fechados: para verificar isso, dentro do "every" testamos se TODOS os itens forem false.
  "every" retornará "true" se TODOS os "item" dentro de "aberto" forem iguais a "false" (devido à condição !item, que também poderia ser feita como "item === false).
  OBS: É importante lembrar, que no método every, é necessário que TODOS os itens atendam à condição imposta. Caso apenas um não esteja de acordo, o método já retornará false.

  A segunda parte da condição (OU (||)), testa se somente o item atualmente enviado via posição (index) está aberto (true).

  Caso todos os itens estejam fechados (false), significa que está na tela inicial, onde mostra todas as opções de collapses/botões coloridos com os icones na vertical.
  Caso algum dos itens esteja aberto (algum item seja igual a "true"), somente este será exibido na tela, com o icone na horizontal.
  */

  const verificaAberto = (index) => aberto.every((item) => !item) || aberto[index];

  return (
    <>
      {/*
      O botão de voltar tem dois compotamentos possíveis a depender de qual tela esteja sendo exibida.

      1º cenário: Estando na tela padrão inicial onde lista todos os botões coloridos com a opção de click para abrir algum collapse,
      o botão de voltar irá retornar para listagem com todas as cartas de serviço pertencentes à mesma secretaria atualmente selecionada.

      2º cenário: Estando na tela em que algum dos botões foi clicado e portanto o collapse desse botão está aberto, o botão de voltar irá
      basicamente fechar o collapse e retornar para a tela padrão inicial, mostrando novamente todas as opções de botões coloridos possíveis a serem clicados.

      Fluxo até aqui:
      Tela listando todas as secretarias para carta de serviço >>
      Tela listando as cartas de serviços pertencentes à secretaria atualmente selecionada >> (o botão "voltar" no 1º cenário volta para essa tela)
      Tela com os botões coloridos os quais quando clicados, abrem um collapse contendo informações >> (o botão "voltar" no 2º cenário volta para essa tela)
      Tela com os detalhes do collapse selecionado.

      OBS: Esse botão de voltar não deveria estar nesse arquivo, mas sim no arquivo onde é chamado o componente atual, ou seja, deveria estar em "IniciarCartaServicos".
      O botão já esteve no arquivo citado até então, inclusive se eu comparar com arquivos de outras telas, notarei que o padrão realmente
      é deixar o botão no arquivo em que inicializa a tela de detalhes (geralmente tem "Iniciar" no inicio da nomenclatura do arquivo), e que chama o card do componente atual.
      Eu só coloquei o botão aqui nesse arquivo do card do componente pelo fato que precisei fazer essa lógica a mais no botão de voltar, e o useState de "aberto" está no componente.
      */}

      <GridSpaceBetween>
        <Botao
          link
          label="Voltar"
          // Verifico se nenhum dos collapses estão abertos. Caso nenhum esteja aberto, volto para a listagem com todas as cartas. Mas caso algum esteja aberto, então eu apenas
          // resseto o array de "aberto", de forma a fechar o collapse atual (assim como todos) e voltar pra tela com os botões coloridos que dão a opção de selecionar um collapse.
          onClick={() => (aberto.every((item) => !item) ? history.push('/cartadeservicos') : setAberto(abertoDefaultValues))}
        />

        {/* {(DataHoraUltimaAtualizacao) && (
          <p style={{ margin: 0 }}>
            <b>Atualizado em:</b>
            {' '}
            {DataHoraUltimaAtualizacao}
          </p>
        )} */}
      </GridSpaceBetween>

      <ServicoGrid>
        {verificaAberto(0) && (
          <ServicoContainer corFundo="rgb(25, 204, 178)"/* corFonte="rgb(255, 255, 255)" */>
            <ServicoCabecalhoContainer onClick={() => handleClick(0)}>
              <ServicoCabecalhoTitulo title="Informações gerais" aberto={aberto[0]}>
                <InfoGeraisSvg />
                <div>
                  <span>Informações gerais</span>
                </div>
              </ServicoCabecalhoTitulo>
            </ServicoCabecalhoContainer>

            {(aberto[0]) && (
              <ServicoConteudoContainer>
                {Secretaria && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Secretaria</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Secretaria}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Servico && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Serviço</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Servico}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Descricao && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Descrição</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: Descricao }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Setor && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Setor responsável</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: Setor }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {PublicoAlvo && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Público alvo</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{PublicoAlvo}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Documento && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Documentos necessários</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: Documento }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                <ServicoConteudoItem>
                  <ServicoConteudoItemTitulo>Taxa/Preço Público</ServicoConteudoItemTitulo>
                  <ServicoConteudoItemValor style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 30,
                  }}
                  >
                    {Valor && (
                      <span>
                        {!Valor.toLowerCase().includes('não')
                        && (
                          <>R$ </>
                        )}
                        {Valor}
                      </span>
                    )}

                    {LinkTaxa && (
                      <a href={LinkTaxa} target="_blank" title="Acessar mais informações referentes à taxa" rel="noreferrer">
                        Acessar Aqui
                      </a>
                    )}
                  </ServicoConteudoItemValor>
                </ServicoConteudoItem>

                {PrincipaisEtapas && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Principais etapas</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: PrincipaisEtapas }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Prazo && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Prazo máximo p/ prestação</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {Prazo}
                      {' '}
                      dias
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {PrazoObservacao && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Prazo máximo p/ prestação (Observação)</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: PrazoObservacao }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {PossuiNumeroGLPI && PossuiNumeroGLPI.toLowerCase() === 'sim' && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Número de GLPI</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {NumeroGLPI}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}
              </ServicoConteudoContainer>
            )}
          </ServicoContainer>
        )}

        {verificaAberto(1) && (
          <ServicoContainer corFundo="rgb(182, 242, 97)"/* corFonte="rgb(255, 255, 255)" */>
            <ServicoCabecalhoContainer onClick={() => handleClick(1)}>
              <ServicoCabecalhoTitulo title="Canais de atendimento - prestação" aberto={aberto[1]}>
                <PrestacaoSvg />
                <div>
                  <span>Como solicitar o serviço</span>
                </div>
              </ServicoCabecalhoTitulo>
            </ServicoCabecalhoContainer>

            {(aberto[1]) && (
              <ServicoConteudoContainer>
                {Plataforma && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Plataforma</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: Plataforma }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Aplicativo && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Aplicativo móvel</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: Aplicativo }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Email && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>E-mail</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Email}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Endereco && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Endereço</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {Endereco}
                      {Bairro && (
                        <>
                          {', '}
                          {Bairro}
                        </>
                      )}
                      {CEP && (
                        <>
                          {'. '}
                          {CEP}
                        </>
                      )}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {((HorarioFuncionamentoDe && HorarioFuncionamentoDe !== ':') || (HorarioFuncionamentoAte && HorarioFuncionamentoAte !== ':')) && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>
                      Horário de funcionamento
                      {((HorarioFuncionamentoDe2 && HorarioFuncionamentoAte2) && (HorarioFuncionamentoDe2 !== ':' || HorarioFuncionamentoAte2 !== ':')) && (<> (Manhã)</>)}
                    </ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {HorarioFuncionamentoDe && (<>{HorarioFuncionamentoDe}</>)}
                      {HorarioFuncionamentoAte && (
                        <>
                          {' '}
                          até
                          {' '}
                          {HorarioFuncionamentoAte}
                        </>
                      )}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {((HorarioFuncionamentoDe2 && HorarioFuncionamentoDe2 !== ':') || (HorarioFuncionamentoAte2 && HorarioFuncionamentoAte2 !== ':')) && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>
                      Horário de funcionamento (Tarde)
                    </ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {HorarioFuncionamentoDe2 && (<>{HorarioFuncionamentoDe2}</>)}
                      {HorarioFuncionamentoAte2 && (
                        <>
                          {' '}
                          até
                          {' '}
                          {HorarioFuncionamentoAte2}
                        </>
                      )}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Telefone01 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Telefone principal</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Telefone01}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Telefone02 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Telefone secundário</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Telefone02}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {LinkPrograma && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>DIGA</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      Departamento de Informação Geral e Atendimento
                      <a href={LinkPrograma} target="_blank" title="Maiores Informações" rel="noreferrer">Maiores Informações</a>
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}
              </ServicoConteudoContainer>
            )}
          </ServicoContainer>
        )}

        {verificaAberto(2) && (
          <ServicoContainer corFundo="rgb(25, 204, 178)"/* corFonte="rgb(255, 255, 255)" */>
            <ServicoCabecalhoContainer onClick={() => handleClick(2)}>
              <ServicoCabecalhoTitulo title="Canais de atendimento - informação" aberto={aberto[2]}>
                <InformacaoSvg />
                <div>
                  <span>Canais de atendimento</span>
                  {aberto[2] && (<> - </>)}
                  <span>informação</span>
                </div>
              </ServicoCabecalhoTitulo>
            </ServicoCabecalhoContainer>

            {(aberto[2]) && (
              <ServicoConteudoContainer>
                {Site && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Site</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><a href={Site} target="_blank" title="Acessar o site" rel="noreferrer">Acessar o site</a></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Aplicativo2 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Aplicativo móvel</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: Aplicativo2 }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Email2 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>E-mail</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Email2}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Endereco2 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Endereço</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {Endereco2}
                      {Bairro2 && (
                        <>
                          {', '}
                          {Bairro2}
                        </>
                      )}
                      {CEP2 && (
                        <>
                          {'. '}
                          {CEP2}
                        </>
                      )}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {((HorarioFuncionamentoDe3 && HorarioFuncionamentoDe3 !== ':') || (HorarioFuncionamentoAte3 && HorarioFuncionamentoAte3 !== ':')) && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>
                      Horário de funcionamento
                      {((HorarioFuncionamentoDe4 && HorarioFuncionamentoAte4) && (HorarioFuncionamentoDe4 !== ':' || HorarioFuncionamentoAte4 !== ':')) && (<> (Manhã)</>)}
                    </ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {HorarioFuncionamentoDe3 && (<>{HorarioFuncionamentoDe3}</>)}
                      {HorarioFuncionamentoAte3 && (
                        <>
                          {' '}
                          até
                          {' '}
                          {HorarioFuncionamentoAte3}
                        </>
                      )}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {((HorarioFuncionamentoDe4 && HorarioFuncionamentoDe4 !== ':') || (HorarioFuncionamentoAte4 && HorarioFuncionamentoAte4 !== ':')) && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>
                      Horário de funcionamento (Tarde)
                    </ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>
                      {HorarioFuncionamentoDe4 && (<>{HorarioFuncionamentoDe4}</>)}
                      {HorarioFuncionamentoAte4 && (
                        <>
                          {' '}
                          até
                          {' '}
                          {HorarioFuncionamentoAte4}
                        </>
                      )}
                    </ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Telefone03 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Telefone principal</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Telefone03}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {Telefone04 && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Telefone secundário</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor>{Telefone04}</ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}
              </ServicoConteudoContainer>
            )}
          </ServicoContainer>
        )}

        {verificaAberto(3) && (
          <ServicoContainer corFundo="rgb(25, 204, 178)"/* corFonte="rgb(255, 255, 255)" */>
            <ServicoCabecalhoContainer onClick={() => handleClick(3)}>
              <ServicoCabecalhoTitulo title="Legislação" aberto={aberto[3]}>
                <LegislacaoSvg />
                <div>
                  <span>Legislação</span>
                </div>
              </ServicoCabecalhoTitulo>
            </ServicoCabecalhoContainer>

            {(aberto[3]) && (
              <ServicoConteudoContainer>
                {LinkDecreto && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Decreto</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: LinkDecreto }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {LinkLei && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Lei</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: LinkLei }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {LinkPortaria && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Portaria</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: LinkPortaria }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {LinkResolucao && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Resolução</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: LinkResolucao }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}

                {LinkOutros && (
                  <ServicoConteudoItem>
                    <ServicoConteudoItemTitulo>Links extras</ServicoConteudoItemTitulo>
                    <ServicoConteudoItemValor><div dangerouslySetInnerHTML={{ __html: LinkOutros }} /></ServicoConteudoItemValor>
                  </ServicoConteudoItem>
                )}
              </ServicoConteudoContainer>
            )}
          </ServicoContainer>
        )}
      </ServicoGrid>
    </>
  );
};

CardCartaServicos.propTypes = {
  Aplicativo: PropTypes.string,
  Aplicativo2: PropTypes.string,
  Bairro: PropTypes.string,
  Bairro2: PropTypes.string,
  CEP: PropTypes.string,
  CEP2: PropTypes.string,
  DataHoraUltimaAtualizacao: PropTypes.string,
  Descricao: PropTypes.string,
  Documento: PropTypes.string,
  Email: PropTypes.string,
  Email2: PropTypes.string,
  Endereco: PropTypes.string,
  Endereco2: PropTypes.string,
  HorarioFuncionamentoAte: PropTypes.string,
  HorarioFuncionamentoAte2: PropTypes.string,
  HorarioFuncionamentoAte3: PropTypes.string,
  HorarioFuncionamentoAte4: PropTypes.string,
  HorarioFuncionamentoDe: PropTypes.string,
  HorarioFuncionamentoDe2: PropTypes.string,
  HorarioFuncionamentoDe3: PropTypes.string,
  HorarioFuncionamentoDe4: PropTypes.string,
  LinkDecreto: PropTypes.string,
  LinkLei: PropTypes.string,
  LinkOutros: PropTypes.string,
  LinkPortaria: PropTypes.string,
  LinkPrograma: PropTypes.string,
  LinkResolucao: PropTypes.string,
  LinkTaxa: PropTypes.string,
  NumeroGLPI: PropTypes.string,
  Plataforma: PropTypes.string,
  PossuiNumeroGLPI: PropTypes.string,
  Prazo: PropTypes.string,
  PrazoObservacao: PropTypes.string,
  PrincipaisEtapas: PropTypes.string,
  PublicoAlvo: PropTypes.string,
  Secretaria: PropTypes.string,
  Servico: PropTypes.string,
  Setor: PropTypes.string,
  Site: PropTypes.string,
  Telefone01: PropTypes.string,
  Telefone02: PropTypes.string,
  Telefone03: PropTypes.string,
  Telefone04: PropTypes.string,
  Valor: PropTypes.string,
};

CardCartaServicos.defaultProps = {
  Aplicativo: '',
  Aplicativo2: '',
  Bairro: '',
  Bairro2: '',
  CEP: '',
  CEP2: '',
  DataHoraUltimaAtualizacao: '',
  Descricao: '',
  Documento: '',
  Email: '',
  Email2: '',
  Endereco: '',
  Endereco2: '',
  HorarioFuncionamentoAte: '',
  HorarioFuncionamentoAte2: '',
  HorarioFuncionamentoAte3: '',
  HorarioFuncionamentoAte4: '',
  HorarioFuncionamentoDe: '',
  HorarioFuncionamentoDe2: '',
  HorarioFuncionamentoDe3: '',
  HorarioFuncionamentoDe4: '',
  LinkDecreto: '',
  LinkLei: '',
  LinkOutros: '',
  LinkPortaria: '',
  LinkPrograma: '',
  LinkResolucao: '',
  LinkTaxa: '',
  NumeroGLPI: '',
  Plataforma: '',
  PossuiNumeroGLPI: '',
  Prazo: '',
  PrazoObservacao: '',
  PrincipaisEtapas: '',
  PublicoAlvo: '',
  Secretaria: '',
  Servico: '',
  Setor: '',
  Site: '',
  Telefone01: '',
  Telefone02: '',
  Telefone03: '',
  Telefone04: '',
  Valor: '',
};

export default CardCartaServicos;
